import { Model } from '../interface/Model.ts';

class GetModelsResponse {
	models: Model[];

	constructor(models: Model[]) {
		this.models = models;
	}

	formatModelsData() {
		if (Array.isArray(this.models)) {
			const formattedModels = {};
			this.models.map((model) => {
				const category =
					Array.isArray(model.categories) && model.categories.length > 0 ? model.categories : null;
				formattedModels[model.id] = {
					id: model.id,
					label: model.name,
					name: model.sd_model,
					image: model.image_url,
					category,
					runCount: model.run_count,
					baseModel: model.base_model,
					subText: model.sub_text,
					highlighted: model.highlighted,
				};
				return null;
			});
			return formattedModels;
		}
		return {};
	}
}

export default GetModelsResponse;
